export const ROOT = '/';
export const TESTS = '/tests';
export const ERROR = '/error';